var map = {
	"./burgermaster.png": "d605",
	"./flowersvg.png": "1509",
	"./melissaPortfolio.png": "af98",
	"./moist.png": "17b0",
	"./screwball.jpg": "82b9",
	"./spinningwheel.png": "a7fa",
	"./toughdrink.png": "2052",
	"./wipeclean.gif": "77ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "341a";